import React from "react";

import { useCardContext } from "./card-provider";
import clsx from "clsx";
import { Icon } from "@app/components/icon";

type Props = {
  url?: string;
  text?: string;
};

function CardButton({ url, text }: Props) {
  const { useFieldValue } = useCardContext();
  const backgroundAsset = useFieldValue("background_asset");

  if (!url || !text) return null;

  const isIcon = text.includes("icon:");

  return (
    <a
      className={clsx(
        "btn btn-sm whitespace-nowrap",
        isIcon && "btn-icon",
        backgroundAsset
          ? "group-ui-[dark]/card:btn-solid-dark group-ui-[light]/card:btn-solid-light"
          : "group-ui-[dark]/card:btn-outline-dark group-ui-[light]/card:btn-outline-light",
      )}
      href={url}
    >
      {isIcon ? <Icon id={text.split(":").pop() ?? ""} className="size-4" /> : text}
    </a>
  );
}

export function CardButtons() {
  const { useFieldValue } = useCardContext();

  const cta1Text = useFieldValue("cta_1_text");
  const cta1Url = useFieldValue("cta_1_url");
  const cta2Text = useFieldValue("cta_2_text");
  const cta2Url = useFieldValue("cta_2_url");

  return (
    <div className="pointer-events-auto flex items-center gap-4 group-ui-[small]/card:flex-col group-ui-[left]/card:items-start group-ui-[right]/card:items-end">
      <CardButton url={cta1Url?.value} text={cta1Text?.value} />
      <CardButton url={cta2Url?.value} text={cta2Text?.value} />
    </div>
  );
}
